export const API_URL = process.env.REACT_APP_API_URL as string;
export const DELIVERY_API_ENDPOINT_V1 = process.env
  .REACT_APP_DELIVERY_API_ENDPOINT_V1 as string;
export const DELIVERY_API_ENDPOINT_V2 = process.env
  .REACT_APP_DELIVERY_API_ENDPOINT_V2 as string;
export const INGEST_API_ENDPOINT_V2 = process.env
  .REACT_APP_INGEST_API_ENDPOINT_V2 as string;
